import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/scroll";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Verify from "@/pages/Verify";
import Account from "@/pages/Account";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CookieBanner from "@/components/CookieBanner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App grain">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/integritetspolicy" element={<Privacy />} />
              <Route path="/logga-in" element={<Login />} />
              <Route path="/registrera" element={<Register />} />
              <Route path="/verifiera" element={<Verify />} />
              <Route path="/mitt-konto" element={<Account />} />
              <Route path="/glomt-losenord" element={<ForgotPassword />} />
              <Route path="/aterstall-losenord" element={<ResetPassword />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
